module.exports = __webpack_public_path__ + "img/icon2.67f7e1f1.svg";